import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import { connect } from "react-redux";
import {
  fetchToken,
  patchAddUser,
  fetchIdamanEdtpToken
} from "api/login/index";

import { fetchDataipman } from "api/portal/index";

import { pushToken } from "actions/login";
import { pushCampaign } from "actions/dashboard";
import { withRouter, Redirect } from "react-router";
import { fetchNotif } from "api/notification/index";
import queryString from "query-string";

 import GoogleLogin from "react-google-login";
// import { patchAddUser } from "api/login/index";
import { fetchCompanyInit } from "api/notification/index";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Modal from "@material-ui/core/Modal";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import { pushLoader } from "../../actions/main";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha
} from "assets/libs/react-simple-captcha";

import LoginIdaman from "./LoginPageIdaman";

import Config from "../../config/";
const ROOT_URL = Config.rooturl;
const ROOT_LOCAL = Config.ownroot;

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardAnimaton: "cardHidden",
      username: "",
      password: "",
      token: null,
      open: false,
      headertext: "",
      bodyText: "",
      footerText: "",
      logins: false,
      msg: "",
      showPassword: false,
      captchaValue: "",
      messageCaptcha: ""
    };
  }

  handleIdamanLoginError = error => {
    console.log(error);

    if (error && error.response && error.response.status === 403) {
      window.location = "/pages/403";
      return;
    }

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, document.title, "/pages/login");
    }

    this.setState({
      msg: "Login Idaman gagal diproses. Silakan coba lagi atau hubungi admin EDTP."
    });
  };

  finishIdamanLogin = async (response, access_token, userlevel) => {
    if (!response) {
      throw new Error("Empty EDTP token response");
    }

    this.props.pushToken(response.data);
    this.props.pushCampaign(true);
    localStorage.setItem("id", response.data.user_id);
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("name", response.data.name);
    localStorage.setItem("email", response.data.email);
    localStorage.setItem("oauth", access_token);
    localStorage.setItem("userlevel", userlevel);
    localStorage.setItem("company_code", response.data.company_code);

    if (response.data.picture_url != "") {
      localStorage.setItem("picture_url", `${ROOT_URL}${response.data.picture_url}`);
    } else {
      localStorage.setItem("picture_url", `${ROOT_URL}publics/avatar.jpg`);
    }

    localStorage.setItem("gender", response.data.gender);
    localStorage.setItem("brithday", response.data.brithday);
    localStorage.setItem("job", response.data.job);
    localStorage.setItem("description", response.data.description);
    localStorage.setItem(
      "company_img",
      `${ROOT_URL}publics/logo_comp/register5_GbUGe5X.jpg`
    );

    try {
      const ipResponse = await fetch("https://ipapi.co/json/");
      const result = await ipResponse.json();
      localStorage.setItem("ipaddress", result.ip);
      localStorage.setItem("location", result.city);
    } catch (error) {
      console.log(error);
    }

    try {
      const responsee = await fetchCompanyInit(response.data.company_code);
      localStorage.setItem(
        "company_img",
        `${ROOT_URL}${responsee.data.results[0].company_img}`
      );
    } catch (error) {
      localStorage.setItem(
        "company_img",
        `${ROOT_URL}publics/logo_comp/register5_RFl0OKI.jpg`
      );
      console.log(error);
    }

    this.setState({ msg: "", logins: true });
  };

  processIdamanLogin = async access_token => {
    this.props.pushLoader(true);

    try {
      const tokenResponse = await fetchIdamanEdtpToken(access_token);
      await this.finishIdamanLogin(
        tokenResponse,
        access_token,
        tokenResponse.data.userlevel
      );
    } catch (error) {
      this.handleIdamanLoginError(error);
    } finally {
      this.props.pushLoader(false);
    }
  };

  handleClose = () => {
    this.setState({ open: !this.state.open });
  };

  UNSAFE_componentWillMount() {
    // fetchEmailExist("admin@pertamina.com")
    // .then(responsee => {
    //   console.log(responsee);
    // })
    // .catch(error => {

    //   console.log(error);

    // });

    // patchAddUseroauth(
    //   'aha',
    //   'aha4@gmail.com',
    //   'asdasd',
    //   'pertamina01' ,
    //   'asd',
    //   3
    // )
    //   .then(responsex => {
    //   console.log(responsex);
    // })
    // .catch(error => {

    //   console.log(error);

    // });

    this.props.pushLoader(false);
    localStorage.clear();

    // fetchDataipman('YGJL')
    //   .then(response => {
    //     console.log(response)
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
    const idamanCallback = window.location.hash.replace(/^#/, "");

    if (idamanCallback && idamanCallback != "logout") {
      const idamanParams = queryString.parse(idamanCallback);

      if (idamanParams.access_token) {
        this.processIdamanLogin(idamanParams.access_token);
      } else {
        this.handleIdamanLoginError(
          new Error("Access token Idaman tidak ditemukan")
        );
      }
    }

    //

    //
    // let urlnya = urls.replace("login#", "login?");
    // alert(urlnya[0])

    // //
    // // const queryParams = new URLSearchParams(urlnya);
    // //
    // // const id_token = queryParams.get('id_token');
    // alert(urls);
    // alert(urlnya);

    // fetchNotif()
    //   .then(response => {
    //     if (response != null) {
    //       this.setState({
    //         open: true,
    //         bodyText: response.data.results[0].bodyText,
    //         headerText: response.data.results[0].headerText
    //       });
    //     }
    //   })
    //   .catch(error => {
    //     //this.props.pushToken(error);
    //   });
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  componentDidMount() {
    loadCaptchaEnginge(6);
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }

  handleChangeEmail = event => {
    this.setState({ username: event.target.value });
  };

  handleChangePassword = event => {
    this.setState({ password: event.target.value });
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  pushLoginIdaman = e => {
    this.setState({ open: true });
  };

  pushLogin = e => {
    if (validateCaptcha(this.state.captchaValue) === true) {
      e.preventDefault();
      // callback
      fetchToken(this.state.username, this.state.password)
        .then(response => {
          if (response != null) {
            this.props.pushCampaign(true);
            this.props.pushToken(response.data);
            localStorage.setItem("id", response.data.user_id);
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("name", response.data.name);
            localStorage.setItem("email", response.data.email);
            localStorage.setItem("oauth", "");
            localStorage.setItem("userlevel", response.data.userlevel);
            localStorage.setItem("company_code", response.data.company_code);
            if (response.data.picture_url != "") {
              localStorage.setItem(
                "picture_url",
                `${ROOT_URL}${response.data.picture_url}`
              );
            } else {
              localStorage.setItem(
                "picture_url",
                `${ROOT_URL}publics/avatar.jpg`
              );
            }

            localStorage.setItem("gender", response.data.gender);
            localStorage.setItem("brithday", response.data.brithday);
            localStorage.setItem("job", response.data.job);
            localStorage.setItem("description", response.data.description);

            localStorage.setItem(
              "company_img",
              `${ROOT_URL}publics/logo_comp/register5_GbUGe5X.jpg`
            );

            fetch("https://ipapi.co/json/")
              .then(res => res.json())
              .then(result => {
                localStorage.setItem("ipaddress", result.ip);
                localStorage.setItem("location", result.city);
              });

            fetchCompanyInit(response.data.company_code)
              .then(responsee => {
                localStorage.setItem(
                  "company_img",
                  `${ROOT_URL}${responsee.data.results[0].company_img}`
                );
                this.setState({
                  logins: true
                });
              })
              .catch(error => {
                localStorage.setItem(
                  "company_img",
                  `${ROOT_URL}publics/logo_comp/register5_RFl0OKI.jpg`
                );
                console.log(error);
                this.setState({
                  logins: true
                });
              });
            this.setState({ msg: "" });
          }
        })
        .catch(error => {
          if (
            error &&
            error.response &&
            error.response.status === 400
          ) {
            this.setState({ msg: "Wrong username or password" });
          } else if (
            error &&
            error.response &&
            error.response.status === 429
          ) {
            this.setState({ msg: "Too many attempts, please wait a moment." });
          } else {
            this.setState({ msg: "Login failed, please try again." });
          }
          this.props.pushToken(error);

        });
    } else {
      this.setState({
        messageCaptcha: "Captcha does not match"
      });
    }
  };

  loginAgain = response => {
    fetchToken(response.data.email, response.data.social_id)
      .then(response => {
        if (response != null) {
          this.props.pushToken(response.data);
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("name", response.data.name);
          localStorage.setItem("email", response.data.email);
          localStorage.setItem("oauth", "");
          localStorage.setItem("picture_url", response.data.picture_url);
          localStorage.setItem("userlevel", response.data.userlevel);
          localStorage.setItem("company_code", response.data.company_code);
          this.props.pushCampaign(true);
          this.props.history.push("/portal");
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  responseFacebook = response => {
    fetchToken(response.email, response.userID)
      .then(response => {
        if (response != null) {
          this.props.pushToken(response.data);
          localStorage.setItem("id", response.data.user_id);
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("name", response.data.name);
          localStorage.setItem("email", response.data.email);
          localStorage.setItem("picture_url", response.data.picture_url);
          localStorage.setItem("gender", response.data.gender);
          localStorage.setItem("brithday", response.data.brithday);
          localStorage.setItem("job", response.data.job);
          localStorage.setItem("description", response.data.description);
          localStorage.setItem("userlevel", response.data.userlevel);
          this.props.history.push("/portal");
        }
      })
      .catch(error => {
        patchAddUser(
          response.name,
          response.email,
          response.userID,
          response.userID,
          response.picture.data.url
        )
          .then(response => {
            if (response != null) {
              this.loginAgain(response);
            }
          })
          .catch(error => {});
      });
  };

  responseGoogle = response => {};

  handleClose = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    const { classes } = this.props;
    if (this.state.logins) {
      this.props.pushCampaign(true);
      this.props.history.push("/portal");
    }
    return (
      <div id="tester" className={classes.loginPage}>
        <GridContainer
          justify="center"
          alignItems="center"
          className={classes.loginGrid}
        >
          <GridItem md={7} lg={8} className={classes.loginSpacer} />
          <GridItem
            xs={12}
            sm={8}
            md={4}
            lg={3}
            className={classes.loginFormColumn}
          >
            <CardBody className={classes.loginFormBody}>
              <div id="tester2" className={classes.loginTitleWrap}>
                <h4 className={classes.cardTitle}>Log In to EDTP 3.0</h4>
              </div>

              <Divider />
              <FormControl fullWidth={true} style={{ marginTop: "25px" }}>
                <TextField
                  id="username"
                  variant="outlined"
                  label="username"
                  onChange={this.handleChangeEmail}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Email className={classes.inputAdornmentIcon} />
                      </InputAdornment>
                    )
                  }}
                  margin="normal"
                />
              </FormControl>
              <FormControl fullWidth={true}>
                <TextField
                  id="password"
                  variant="outlined"
                  label="password"
                  onChange={this.handleChangePassword}
                  type={this.state.showPassword ? "text" : "password"}
                  value={this.state.password}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon className={classes.inputAdornmentIcon}>
                          lock_outline
                        </Icon>
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={this.handleClickShowPassword}
                          onMouseDown={this.handleMouseDownPassword}
                        >
                          {this.state.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </FormControl>
              <font color="red">{this.state.msg}</font>
              <div style={{ marginTop: 8 }} />
              <LoadCanvasTemplate />
              <FormControl fullWidth={true}>
                <TextField
                  id="captchaLogin"
                  variant="outlined"
                  label="Captcha"
                  onChange={e =>
                    this.setState({
                      captchaValue: e.target.value,
                      messageCaptcha: ""
                    })
                  }
                  margin="normal"
                />
              </FormControl>
              <font color="red">{this.state.messageCaptcha}</font>
              <hr />
              <Button
                type="submit"
                color="behance"
                style={{ marginBottom: "25px" }}
                fullWidth
                round
                onClick={this.pushLogin}
              >
                Log In
              </Button>
              <a href="/pages/loginidaman" style={{ color: "#1769ff" }}>
                <Button
                  type="submit"
                  color="white"
                  style={{ marginBottom: "25px" }}
                  fullWidth
                  round
                >
                  Continue With Idaman
                </Button>
              </a>
            </CardBody>
          </GridItem>
        </GridContainer>
        {/*  <LoginIdaman/>*/}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: state.token
  };
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
  pushToken: PropTypes.string,
  pushLoader: PropTypes.func,
  history: PropTypes.object,
  pushCampaign: PropTypes.bool
};

export default withStyles(loginPageStyle)(
  withRouter(
    connect(
      mapStateToProps,
      { pushToken, pushLoader, pushCampaign }
    )(LoginPage)
  )
);
